<template>
  <div class="exercise-icon" style="padding: 6px" :class="getBackgroundColor">

<!--    Air Element Icon-->
    <svg v-if="element==='air_element'" id="air-element" class="fill-current"
         xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 617 621"
         overflow="visible" xml:space="preserve">
      <path d="M308.7,0.3C141.9,0.2,2.8,137.9,0.3,306c-2.6,173.4,141,317.2,311.9,315.2c165.9-1.9,304.9-140.5,304.9-310.5
        C617.1,139.9,476.6,0.3,308.7,0.3z M311.7,571.7c-145.2,1.6-267.2-119.3-265-265c2.1-141.3,120.3-257,262-257
        c74.2,0,142,31.8,190.1,82.4c-24.9,2.3-45.1,6.2-59.8,9.6c-22.2,5.2-29.3,8.7-83,24c-31.7,9.1-47.8,13.6-57,15
        c-40.2,6-72.2,1.1-86.8-1.7c-10.4-2-19-4.4-25.2-6.3c0,0,22.3,11.2,24,12c15.4,7.7,49.7,17.2,101,16c26.1-0.6,20-3.1,90-11
        c54.6-6.2,71.1-6.1,77-6c24,0.3,44.8,3.1,61.5,6.2c11.1,20.9,19.5,43.4,24.5,67.1c-15.6-2.2-35-3.9-57-3.3
        c-55.7,1.5-100.1,16.5-143,31c-12.2,4.1-64.7,21.3-110.8,25.5c-2.8,0.3-5.4,0.4-8.2,0.5c-31.1,1-57.9-2.2-76.8-5.7
        c-7.5-1.4-17.9-3.7-30.2-7.3c7.3,4.5,18.2,10.5,32,16c16,6.4,52,18.4,124,13c34.9-2.6,29.6-5.6,92-14c48.6-6.5,72.9-9.8,102-9
        c20,0.5,48,3,81.7,11.6c-0.5,29.1-5.9,57.1-15.5,83.2c-12.4-1.6-25.5-3.1-35.2-3.8c-78.9-5.9-152,23.8-172,32c-9.8,4-35,14.7-65,22
        c-23.9,5.8-43.6,7.6-50.7,8.2c-7,0.6-12.2,0.8-13.3,0.8c-30.6,0.7-56.8-3.3-75.4-7.4c-7.6-1.7-17.7-4.5-29.6-8.6
        c8.3,4.9,20.1,11.3,35,17c25.7,9.8,50.7,13.9,78,15c7.9,0.3,14.9,0.3,21.8,0c46.5-2.2,84.7-11.2,111.2-17
        c55.8-12.2,83.7-18.3,115-18c21.4,0.2,40.7,3,57.5,6.7C486.6,520.3,404,570.7,311.7,571.7z" />
    </svg>

<!--    Earth Element Icon-->
    <svg v-else-if="element==='earth_element'" id="earth-element" class="fill-current"
         xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 2368 2383"
         overflow="visible" xml:space="preserve">
      <path d="M1184.2-0.3C544-0.4,10,528.1,0.3,1173.2c-10,665.4,541.4,1217.6,1197.4,1210.1C1834.4,2376,2368,1843.9,2368,1191.5
        C2368,535.6,1828.7-0.2,1184.2-0.3z M1369.6,2175.9c13-22.5,25.8-49.1,35.4-79.3c12.3-38.7,37.4-122.6,0-218.3
        c-16.9-43.1-37.7-66.3-57.6-134.5c-13.6-46.7-13-67.3-7.7-86.3c5.5-19.7,17.5-42.1,72.9-93.9c65-60.8,79.7-59,130.5-106.6
        c44-41.3,83.9-78.6,96-132c10.2-44.9-3.4-82.9-15.4-106.6c13.9,80.7-21.7,129.9-42.2,152.3c-33.2,36.3-81.6,61.9-122.8,83.8
        c-65.7,34.8-102.9,42.2-149.7,78.7c-29.8,23.2-47.5,45.9-57.6,60.9c-0.2-0.3-70.5-83.3-115.2-157.4
        c-32.9-54.7-65.8-109.2-71.4-183.9c-6.1-80.1,22.1-143.4,40.7-184.1c31.3-68.4,75.4-109.3,69.1-111.7c-6.7-2.6-61.4,41.9-99.8,99
        c-13.8,20.5-32.2,52.7-46.1,106.6c-10.1,39.1-31.4,126.8,0,238.6c14.6,52.2,19.2,32.9,84.4,185.3c18,42.1,30.9,74.6,57.2,120.6
        c7.8,13.7,15.9,27.1,27.3,49.5c18,35.7,29.5,58.8,34.5,88.8c2.4,14.4,4.2,35.2,0,60.9c-90.6-50.4-161.8-78-211.1-93.9
        c-19-6.1-74.4-23.4-144.3-52.4c-28.1-11.7-42.2-17.5-59.2-26.3c-26.4-13.6-82-42.8-122.8-93.9c-33.1-41.5-43.1-80.6-46.1-106.6
        c-0.8,10.7-3.5,46.3-3.8,50.8c-2.9,43.5,31.7,100.7,72.9,142.1c35,35.2,85.2,61.2,184.2,111.7c112,57.1,130.2,56.5,184.2,93.9
        c53.4,37,107.5,74.5,107.5,126.9c0,43.4-36.1,76.5-57.6,93.9c-17.8,14.4-36.3,26.1-54,35.6c-506-52.6-911.8-490.9-903.8-1011.9
        c7.3-477.4,359.7-878.8,815-968c-16.4,25.5-33.6,57.8-45.7,95.9c-12.3,38.6-37.4,122.2,0,217.6c16.9,42.9,37.7,66.1,57.6,134.1
        c13.6,46.5,13,67.1,7.7,86c-5.5,19.6-17.5,42-72.9,93.6c-65,60.6-79.7,58.8-130.5,106.3c-44,41.2-83.9,78.4-96,131.6
        c-10.2,44.7,3.4,82.7,15.4,106.3c-13.9-80.4,21.7-129.5,42.2-151.8c33.2-36.1,81.6-61.7,122.8-83.5c65.7-34.7,102.9-42,149.7-78.4
        c29.8-23.2,47.5-45.7,57.6-60.7c0.2,0.3,70.5,83,115.2,156.9c32.9,54.5,65.8,108.8,71.4,183.4c6.1,79.8-22.1,142.9-40.7,183.5
        c-31.3,68.2-75.4,108.9-69.1,111.3c6.7,2.6,61.4-41.8,99.8-98.7c13.8-20.5,32.2-52.5,46.1-106.3c10.1-39,31.4-126.4,0-237.9
        c-14.6-52-19.2-32.8-84.4-184.7c-18-42-30.9-74.3-57.2-120.2c-7.8-13.7-15.9-27-27.3-49.3c-18-35.6-29.5-58.6-34.5-88.6
        c-2.4-14.3-4.2-35.1,0-60.7c90.6,50.3,161.8,77.7,211.1,93.6c19,6.1,74.4,23.3,144.3,52.3c28.1,11.7,42.2,17.5,59.2,26.2
        c26.4,13.5,82,42.7,122.8,93.6c33.1,41.3,43.1,80.3,46.1,106.3c0.8-10.6,3.5-46.2,3.8-50.6c2.9-43.4-31.7-100.4-72.9-141.7
        c-35-35.1-85.2-61-184.2-111.3c-112-57-130.2-56.3-184.2-93.6C1213,431.7,1159,394.3,1159,342c0-43.3,36.1-76.3,57.6-93.6
        c29.5-23.8,61.1-40.4,87.4-51.5c493,59.9,885.9,483.9,885.9,994.5C2189.8,1679.9,1830.3,2088,1369.6,2175.9z"/>
    </svg>

<!--    Fire Element Icon-->
    <svg v-else-if="element==='fire_element'" id="fire-element" class="fill-current"
         xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 616.9 621"
         overflow="visible" xml:space="preserve">
      <path d="M308.5,0C141.7,0,2.6,137.7,0,305.8C-2.6,479.2,141,623,311.9,621c166-1.9,305-140.5,305-310.5C616.9,139.6,476.4,0,308.5,0
        z M46.5,306.5c2.1-141.2,120.3-257,262-257c142.6,0,262,117.4,262,261c0,38.3-8.5,74.6-23.6,107.4c-6.2-14.3-13.7-29.8-20.8-39.9
        c-13.8-19.4-23-19.9-63.1-49.7c-32.4-24-48.8-36.4-57.7-52.6c-18.6-33.7-13.5-68.6-13.5-68.6c-2.8,9.8-6.6,27.4-3.5,49.2
        c0.9,6.2,3.3,19.4,10.4,34.2c10.4,21.7,28.6,38,64.5,69.8c11,9.8,18.3,15.8,27.1,27.5c2.4,3.4,14.8,19.4,19,34.8
        c7.6,27.4-4.5,59.5-28.4,83.5c-3.7,3.2-7.5,6.4-11.4,9.4c3.4-27,0.5-48.2-2.6-62.1c-8.5-38.3-28.3-65.3-56-103
        c-31.2-42.6-40.9-43-64-82c-23.5-39.7-28-63.8-28-83c0-19.4,4.7-35.9,7-43c6.2-19.4,15.2-33.8,22-43c-6.7,7.3-15.2,17.9-23,32
        c0,0-14.9,27-19,58c-6,44.9,17.3,86.2,49,141c29.3,50.5,48.2,68.7,60,112c4.7,17.3,8.3,38.8,2,63c-4.2,16.2-11.6,28.4-17,36
        c0,0-0.9-21-9-46c-6.8-21-15.5-24.2-44-62c-23.1-30.6-34.7-46.2-38-63c-6.9-34.9,9-64,9-64c-5.9,7.8-15.1,22-19,42
        c-1.1,5.7-3,17.9-1,33c3,22,15,41.7,39,80c7.4,11.8,12.4,19.2,17,32c1.3,3.6,7.9,21.3,7,36c-0.9,14.3-7.7,28-18.5,39.9
        c-10.1,1.3-20.4,2.1-30.9,2.2c-18.6,0.2-36.8-1.6-54.4-5.2c-3.8-6.1-7.2-13.8-8.2-22.9c-1.4-12.4,2-22.2,6-33
        c8.7-23.6,17.2-23.9,25-45c3.8-10.3,10.1-28.1,4-47c-5.3-16.5-19-26-19-26c2.8,5.5,7.6,16.6,7,31c-0.6,16.7-8.1,28.5-11,33
        c-9.2,14.2-13.8,9.9-29,29c-8.6,10.9-15.1,22.3-18.5,28.3c-1.1,1.9-2.3,3.9-3.5,6.7c-4.9,11.8-6,20-6,20s-16.4-23.4-16-49
        c0.2-10.3,2.3-21.3,16-50c15.6-32.5,23.8-41,42-75c15.5-29,23.3-43.5,27-59c3.3-13.6,10.6-45.8-4-78c-8.5-18.7-23-30-23-30
        c6.1,11.8,13.1,29.2,15,51c0.8,8.5,2,23.6-3,42c-1.1,4.1-5.3,17.8-23,44c-9.2,13.6-13.2,17.1-33,41c-23.3,28.1-35.1,42.4-43,56
        c-8.3,14.3-17.1,29.8-21,52c-0.7,3.9-0.7,10.7-0.4,18.2c-15.8-15.4-24.8-33.8-23.3-51.3c1.2-13.5,10.2-28.6,12-31.7
        c6.3-11,12.4-17,21.3-26.6c29.1-31.3,43.8-47.3,49.9-66.9c4.1-13.4,4-24.8,3.7-30.2c-1.1-18.8-8.1-33.2-12.8-41.2
        c0,0,11.6,29-0.2,59.7c-5.7,14.8-19.3,27.3-46.5,51.6c-33.5,30.1-42.5,31.6-52.3,49.7c-3.2,5.8-6,13.5-8.6,21.5
        C58.4,399.2,45.8,354.2,46.5,306.5z"/>
    </svg>

  </div>
</template>

<script>
export default {
  name: "ExerciseIcon",
  props: {
    element: {
      type: String,
      required: true
    }
  },
  computed: {
    getBackgroundColor() {
      switch (this.element) {
        case 'air_element':
          return 'accent-green'
        case 'earth_element':
          return 'accent-amber'
        case 'fire_element':
          return 'accent-orange'
        default: return null
      }

    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/colors";
.accent-green {
  background: $accentGreen;
}
.accent-amber {
  background: $accentAmber;
}
.accent-orange {
  background: $accentOrange;
}
</style>